<template>
  <div class="echartsAndUl">
    <a-spin :spinning="loading">
      <div class="echartsAndSelect">
        <div :id="echartsId" class="echarts" v-show="showEcharts"></div>
        <a-empty v-show="!showEcharts" class="empty"/>
        <a-select v-model="type" style="width: 70px" @change="changeSelect" class="select">
          <a-select-option :value="1">
            月度
          </a-select-option>
          <a-select-option :value="2">
            年度
          </a-select-option>
        </a-select>
      </div>
    </a-spin>
    <div class="ranking">
      <span class="rankingTitle">资产分类排名</span>
      <ul>
        <li v-for="(item, index) in ulData" :key="index">
          <span class="assetTitleSpan">
            <span class="indexDiv">{{ index + 1 }}</span>
            <a-tooltip>
              <template slot="title">{{ item.name }}</template>
              <span class="rankingContent">{{ item.name }}</span>
            </a-tooltip>
          </span>
          <span v-if="Number(activeTab) === 3">{{ item.number }}个</span>
          <span v-else>{{ item.number }}万元</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import { mapGetters } from 'vuex'
import { getAssetTotal, getAssetTypeBySort, getChart } from '@/api/assetLedger'
export default {
  name: 'EchartsAndUl',
  props: ['echartsId', 'echartsSearchData', 'activeTab'],
  data () {
    return {
      ulData: [],
      chartDom: null,
      type: 1,
      kanswSeriesData: [],
      mengeSeriesData: [],
      qmjzSeriesData: [],
      xAxisData: [],
      loading: false,
      showEcharts: false
    }
  },
  computed: {
    ...mapGetters(['assetEchartsCompanyId', 'assetEchartsAnlkl'])
  },
  watch: {
    assetEchartsCompanyId (newValue) {
      console.log(newValue)
      // this.searchForm.assetEchartsCompanyId = false
      // console.log(newValue.comid.length > 0)
      // if (newValue.comid.length > 0) {
      //   this.searchForm.assetEchartsCompanyId = true
      // } else {
      //   this.searchForm.assetEchartsCompanyId = false
      // }
      // if (this.searchForm.assetEchartsAnlkl) {
      //   this.getData()
      // }
      // 调用防抖函数
      this.debouncedGetData()
    },
    assetEchartsAnlkl (newValue) {
      // if (!(newValue.anlklList.length === 1 && newValue.anlklList[0] === '资产分类')) {
      //   this.getData()
      // }
      // console.log(newValue.anlklList.length > 0)
      // this.searchForm.assetEchartsAnlkl = false
      // if (newValue.anlklList.length > 0) {
      //   this.searchForm.assetEchartsAnlkl = true
      // } else {
      //   this.searchForm.assetEchartsAnlkl = false
      // }
      // console.log('this.searchForm.assetEchartsAnlkl', this.searchForm.assetEchartsAnlkl)
      // if (this.searchForm.assetEchartsCompanyId) {
      //   this.getData()
      // }
      // 调用防抖函数
      this.debouncedGetData()
    }
  },
  created () {
    // 初始化时创建对于getData函数的防抖
    this.debouncedGetData = this.debounce(this.getData, 200)
  },
  mounted () {
    const that = this
    this.chartDom = echarts.init(document.getElementById(this.echartsId))
    window.addEventListener('resize', function () { // 执行
      that.chartDom.resize()
    })
  },
  methods: {
    // 选择月度/年度
    changeSelect () {
      this.getData()
    },
    // 防抖
    debounce (fn, delay) {
      let timer = null
      this.loading = true
      return function () {
        const context = this
        const args = arguments
        clearTimeout(timer)
        timer = setTimeout(function () {
          fn.apply(context, args)
        }, delay)
      }
    },
    // 获取数据并画图
    getData (data, type) {
      this.xAxisData = []
      this.kanswSeriesData = []
      this.mengeSeriesData = []
      this.qmjzSeriesData = []
      const anlklList = []
      const params = { ...(data || this.echartsSearchData) }
      if (this.assetEchartsAnlkl.anlklList) {
        this.assetEchartsAnlkl.anlklList.forEach((item, index) => {
          if (item !== '资产分类' && (item.indexOf('0-0') === -1)) {
            anlklList.push(item)
          }
        })
      }
      if (this.assetEchartsCompanyId.comid) {
        params.comidList = this.assetEchartsCompanyId.comid.filter(item => item !== '杭氧')
      }
      params.type = this.type
      if (anlklList.length > 0) {
        params.anlklList = anlklList
      }
      // 获取图表数据
      getChart(params).then(res => {
        if (res.status === 0) {
          if (res.data) {
            this.showEcharts = true
            res.data.forEach(item => {
              this.xAxisData.push(item.date)
              this.kanswSeriesData.push(item.kansw)
              this.mengeSeriesData.push(item.menge)
              this.qmjzSeriesData.push(item.qmjz)
            })
          } else {
            this.showEcharts = false
          }
          this.loading = false
          this.$nextTick(() => {
            this.drawEcharts(type || this.activeTab)
          })
        } else {
          this.loading = false
          this.$message.error(res.info.message)
        }
      }).catch(err => {
        this.loading = false
        this.$message.error(err.info.message)
      })
      // 获取右侧排名
      const params2 = { ...params }
      params2.type = type || this.activeTab
      getAssetTypeBySort(params2).then(res => {
        if (res.status === 0) {
          this.ulData = res.data
        } else {
          this.$message.error(res.info.message)
        }
      }).catch(err => {
        this.$message.error(err.info.message)
      })
      // 获取顶部总资产购置价格
      const params3 = { ...params }
      delete params3.type
      getAssetTotal(params3).then(res => {
        if (res.status === 0) {
          this.$emit('setAllAssetPurchasePrice', res.data ? res.data : 0)
        } else {
          this.$message.error(res.info.message)
        }
      }).catch(err => {
        this.$message.error(err.info.message)
      })
    },
    // 画图
    drawEcharts (type) {
      this.$nextTick(() => {
        const that = this
        that.chartDom.resize()
        const seriesType = Number(type)
        const option = {
          title: {
            text: '资产数量变化图(按照资本化日期计算)'
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            },
            formatter: function (params) {
              var relVal = params[0].name
              const unit = seriesType === 3 ? '个' : '万元'
              for (var i = 0, l = params.length; i < l; i++) {
                relVal += '<br/>' + params[i].marker + params[i].seriesName + ':&ensp;' + params[i].value + unit
              }
              return relVal
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: this.xAxisData,
              axisTick: {
                alignWithLabel: true
              }
            }
          ],
          yAxis: [
            {
              // name: '万元',
              type: 'value',
              axisLabel: {
                formatter: seriesType === 3 ? '{value} 个' : '{value} 万元'
              }
            }
          ],
          series: [
            {
              name: seriesType === 1 ? '总资产购置价值' : seriesType === 2 ? '总资产现值总和' : '总资产数量',
              type: 'bar',
              barWidth: '60%',
              data: seriesType === 1 ? this.kanswSeriesData : seriesType === 2 ? this.qmjzSeriesData : this.mengeSeriesData,
              itemStyle: {
                normal: {
                  color: '#4E99FF'
                }
              }
            }
          ],
          dataZoom: [{
            show: true, // 为true 滚动条出现
            realtime: true,
            type: 'slider', // 有type这个属性，滚动条在最下面，也可以不行，写y：36，这表示距离顶端36px，一般就是在图上面。
            height: 30, // 表示滚动条的高度，也就是粗细
            startValue: 0, // 从头开始。
            endValue: 12 // 最多六个
          },
          {
            type: 'inside', // 支持内部鼠标滚动平移
            zoomOnMouseWheel: false, // 关闭滚轮缩放
            moveOnMouseWheel: true, // 开启滚轮平移
            moveOnMouseMove: false // 鼠标移动能触发数据窗口平移
          }]
        }
        this.chartDom.setOption(option)
      })
    }
  }
}
</script>

<style scoped lang="less">
.echartsAndUl {
  display: flex;
  height: 100%;
}
.echartsAndSelect {
  position: relative;
  height: 100%;
  //width: calc(100% - 300px);
  width: 100%;
  .echarts {
    width: 100%;
    height: 100%;
    border-right: 1px solid #DDDDDD;
  }
  .select {
    position: absolute;
    top: 0;
    right: 20px;
  }
  .empty {
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 130px;
  }
}
.ranking {
  width: 300px;
  padding: 30px 0 0 10px;
  height: 100%;
  .rankingTitle {
    display: inline-block;
    font-weight: bold;
    font-size: 20px;
    margin-bottom: 20px;
  }
  ul {
    // 自定义
    --bgcolor: #08409F;
    padding: 0 10px 0 0;
    height: calc(100% - 50px);
    overflow-y: scroll;
    li {
      list-style: none;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
      .assetTitleSpan {
        display: flex;
        flex-direction: row;
        align-items: center;
      }
      .indexDiv {
        display: inline-block;
        background-color: rgb(225, 232, 243);
        width: 30px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        border-radius: 20px;
        color: #000000;
        margin-right: 10px;
      }
      .rankingContent {
        width: auto;
        max-width: calc(100% - 40px);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
      }
    }
    li:nth-child(1) {
      .indexDiv {
        display: inline-block;
        background-color: var(--bgcolor);
        width: 30px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        border-radius: 20px;
        color: #ffffff;
        margin-right: 10px;
      }
    }
    li:nth-child(2){
      .indexDiv {
        display: inline-block;
        background-color: var(--bgcolor);
        width: 30px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        border-radius: 20px;
        color: #ffffff;
        margin-right: 10px;
      }
    }
    li:nth-child(3){
      .indexDiv {
        display: inline-block;
        background-color: var(--bgcolor);
        width: 30px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        border-radius: 20px;
        color: #ffffff;
        margin-right: 10px;
      }
    }
  }
}
/deep/.ant-spin-nested-loading {
  width: calc(100% - 300px);
  .ant-spin {
    max-height: max-content;
  }
  .ant-spin-container {
    width: 100%;
    height: 100%;
  }
}
</style>
